<template>
  <div id="app" class="wrapper">
    <!-- 头部导航 -->
    <navheader></navheader>
    <!--内容-->
    <div class="content">
      <router-view/>

      <el-backtop target=".wrapper" :bottom="100" />
    </div>

    <!-- 底部 -->
    <footeritem></footeritem>

  </div>
</template>
<script>
import navheader from '@/components/navheader.vue'
import footeritem from '@/components/footeritem.vue'
import bus from "@/utils/bus";

export default {
  name: 'Pdf',
  components: {
    navheader,
    footeritem
  },
  watch: {
    '$route' (to, from) {
      window.scrollTo(0, 0);
    }
  },
};
</script>
<style>
@import "./assets/css/main.css";
</style>
